

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';



export interface WardFacilityParameters extends Parameter {
    searchTerm: string;
    defaultOrderBy: string;
  
}

export interface WardFacility {
  id?: number;  
  name:string;
  imgName:string;
  imgLocation:string;
  parameters?: WardFacilityParameters[];
  links?: any;
}

export abstract class WardFacilityData {
  //abstract fireRequest(data: CountryMst, method: string): Observable<any>;
  abstract list(url: string): Observable<WardFacility[]>;
 
}
